import React, { useEffect, useState } from 'react'
import { ReactComponent as BuyClose } from '../../../assets/icons/main/buy-close.svg'
import { ReactComponent as BuyPlus } from '../../../assets/icons/main/buy-order-plus.svg'
import Inputs from '../../../components/inputs/Inputs'
import BuyInput from '../../../components/inputs/BuyInput'
import Button from '../../../components/button/Button'
// import './BuyOrder.css'
import axios from "axios";
import {enqueueSnackbar} from "notistack";
import {Link} from "react-router-dom";
import {roundFractional} from "../../../features/numberRounding";
import { useTranslation } from 'react-i18next'

const BuyOrder = ({balance, stateActive, setStateActive, AVGdata, coinFrom, coinTo, orderType, setOrderType}) => {
    // const [ activeBlock, setActivBlock ] = useState(false)
    const {t} = useTranslation()
    const token = localStorage.getItem("token")
    const [ menuSelection, setMenuSelection ] = useState(2);
    const [ limitMarket, setLimitMarket ] = useState(1)

    const [ tp, setTP ] = useState(0)
    const [ sl, setSL ] = useState(0)

    const [ price, setPrice ] = useState("")
    const [ count, setCount ] = useState(0)
    const [ leverage, setLeverage ] = useState("3")
    const [ percent, setPercent ] = useState("")
    const [ volume, setVolume ] = useState(0)

    const [avgBalance, setAvgBalance] = useState()
    

    const getBalance = () => {
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/common`, {headers: {"Authorization" : `Bearer ${token}`}})
        .then(res => {
            console.log(res.data, "BALANCE");
            setAvgBalance(res.data)
        })
    }

    useEffect(()=>{
        getBalance()
    },[])

    const handleSubmit = async (event) => {
        // event.preventDefault();

        if(!count || !volume){
            enqueueSnackbar(t("buyOrder.errIncorrectData"), {autoHideDuration: 3000, variant: 'error', className: "snackerror"});
        }else if(avgBalance < volume || !avgBalance){
            // alert("Недостаточно средств")
            enqueueSnackbar(t("buyOrder.errNoHaveMoney"), {autoHideDuration: 3000, variant: 'error', className: "snackerror"});
        }else{
            setPrice(price == "" ? 0 : price)
            // const data = {
            //     margin: AVGdata.lastPrice * count,
            //     total: price * count,
            //     price: Number(limitMarket === 2 ? price : AVGdata.lastPrice),
            //     amount: count,
            //     action: orderType === 1 ? 'buy' : 'sell',
            //     name: coinTo,
            //     coin: coinFrom,
            //     leverage: leverage,
            //     take_profit: tp,  // Здесь подставьте значение тейк-профита, если оно есть
            //     stop_loss: sl,  // Здесь подставьте значение стоп-лосс, если оно есть
            //     short_long: orderType === 2,
            //     is_limited: limitMarket === 2,
            //     limit: Number(limitMarket === 2 ? price : 0)
            // };

            const data = {
                margin: AVGdata.lastPrice * count,
                total: volume,
                price: limitMarket === 2 ? price : AVGdata.lastPrice,
                amount: count,
                action: orderType === 1 ? 'buy' : 'sell',
                coin: coinFrom,
                // coin_to: coinTo,
                // coin_from: coinFrom,
                name: coinTo,
                leverage: Number(leverage),
                take_profit: tp == "" ? 0 : tp,  // Здесь подставьте значение тейк-профита, если оно есть
                stop_loss: sl == "" ? 0 : sl,  // Здесь подставьте значение стоп-лосс, если оно есть
                short_long: orderType === 2,
                is_limited: limitMarket === 2,
                limit: Number(limitMarket === 2 ? price : 0)
            };

            try {
                const res = await axios.post("https://api-ru.fynex.cc/api/api/share", data, {
                    headers: {"Authorization": `Bearer ${token}`}
                });

                setPrice("");
                setCount("");
                // setLeverage("");
                setPercent("");
                setVolume("");

                enqueueSnackbar(`${t("buyOrder.orderCreate")}`, {autoHideDuration: 3000, variant: 'success', className: "snacksuccess"});
                // reloadUserData()

                // КОСТЫЛЬ(!!!!)
                document.location.reload();
            } catch (error) {
                error.response.data.detail.forEach(errormsg => {
                    // alert(123)
                    enqueueSnackbar(`${t("buyOrder.errArose")}: ${errormsg.msg}`, {autoHideDuration: 3000, variant: 'error', className: "snackerror"});
                });
            }
        }
    };



    const priceHandler = (num) => {
        setPrice(num);
        setVolume(Math.floor10(count * num, -6))
    };
    const amountHandler = (num) => {
        if (limitMarket === 1) {
            setCount(num);
            setVolume(Math.floor10(num * AVGdata.lastPrice, -6))
            console.log(count, "count");
            console.log(volume, "volume");
            
        }
        else {
            setCount(num);
            setVolume(Math.floor10(num * Number(price == "" ? 1 : price), -6))
        }
    };
    const totalHandler = (num) => {
        setVolume(num);
        setCount(Math.floor10(num / AVGdata.lastPrice , -6));
    };


    // useEffect(() => {
    //     alert(AVGdata.lastPrice)
    //     if (limitMarket === 1) {
    //         const calculatedVolume = (price / AVGdata.lastPrice) * count;
    //         setVolume(calculatedVolume ? calculatedVolume.toFixed(2) : "");
    //     } else {
    //         const calculatedVolume = price * count;
    //         setVolume(calculatedVolume ? calculatedVolume.toFixed(2) : "");
    //     }
    // }, [price, count, AVGdata.lastPrice, limitMarket]);

    // useEffect(() => {
    //     if (limitMarket === 1) {
    //         const calculatedCount = (volume * AVGdata.lastPrice) / price;
    //         setCount(calculatedCount ? calculatedCount.toFixed(2) : "");
    //     } else {
    //         const calculatedCount = volume / price;
    //         setCount(calculatedCount ? calculatedCount.toFixed(2) : "");
    //     }
    // }, [volume, price, AVGdata.lastPrice, limitMarket]);

    return (
        <div className={stateActive == true ? "BuyOrder BuyOrderActive" : "BuyOrder"}>
        <div className="headline">
            <h3>{t("buyOrder.placeOrder")}</h3>
            {/* <BuyClose onClick={()=>setStateActive(false)}/> */}
        </div>
        <div className="buy-menu">
            {/*<span onClick={()=>setMenuSelection(1)}>*/}
            {/*    <h4 className={menuSelection === 1 ? "span-active" : ""}>Спот</h4>*/}
            {/*    <div className={menuSelection === 1 ? "line line-activ" : "line"}></div>*/}
            {/*</span>*/}
            <span onClick={()=>setMenuSelection(2)}>
                <h4 className={menuSelection === 2 ? "span-active" : ""}>{t("buyOrder.futures")}</h4>
                <div className={menuSelection === 2 ? "line line-activ" : "line"}></div>
            </span>
        </div>

        <div className={menuSelection === 2 ? "orderWrapper orderWrapperFutures" : "orderWrapper"}>

            {/* <div className="Spot">
                <div className="slideButtons-wrapper">
                    <div className="slideButtons">
                        <p className={orderType=== 1 ? "active" : ""} onClick={()=>setOrderType(1)}>{t("buyOrider.buy")}</p>
                        <p className={orderType=== 2 ? "active" : ""} onClick={()=>setOrderType(2)}>{t("buyOrider.sell")}</p>
                        <div className={orderType=== 2 ? "dynamicSldier activeSldier" : "dynamicSldier"}></div>
                    </div>
                </div>

                <div className="limitMarket">
                    <p className={limitMarket == 1 ? "active" : ""} onClick={()=>setLimitMarket(1)}>{t("buyOrder.market")}</p>
                    <p className={limitMarket == 2 ? "active" : ""} onClick={()=>setLimitMarket(2)}>{t("buyOrder.limit")}</p>
                </div>

                <div className="available">
                    <h4>{t("buyOrder.available")}</h4>
                    <div className="usdt">{balance} USDT <BuyPlus/></div>
                </div>

                <Inputs>
                    <BuyInput placeholder={t("buyOrder.price")} textData={coinFrom} valueInput={price} setInputChange={priceHandler}/>
                    <BuyInput placeholder={t("buyOrder.count")} textData={coinTo} valueInput={count} setInputChange={amountHandler}/>
                    <div className="buttons">
                        <div className={percent == "25" ? "countPercent precentActive" : "countPercent"} onClick={()=>setPercent("25")}>25%</div>
                        <div className={percent == "50" ? "countPercent precentActive" : "countPercent"} onClick={()=>setPercent("50")}>50%</div>
                        <div className={percent == "75" ? "countPercent precentActive" : "countPercent"} onClick={()=>setPercent("75")}>75%</div>
                        <div className={percent == "100" ? "countPercent precentActive" : "countPercent"} onClick={()=>setPercent("100")}>100%</div>
                    </div>
                    <BuyInput placeholder={t("buyOrder.volume")} textData={coinFrom} valueInput={volume} setInputChange={totalHandler}/>
                </Inputs>

                <Button text={t("buyOrder.buyBtc")}/>
            </div>   */}
        
            <div className="Futures">
                <div className="slideButtons-wrapper">
                        <div className="slideButtons">
                            <p className={orderType=== 1 ? "active" : ""} onClick={()=>setOrderType(1)}>{t("buyOrder.short")}</p>
                            <p className={orderType=== 2 ? "active" : ""} onClick={()=>setOrderType(2)}>{t("buyOrder.long")}</p>
                            <div className={orderType=== 2 ? "dynamicSldier activeSldier" : "dynamicSldier"}></div>
                        </div>
                    </div>

                    <div className="limitMarket">
                        <p className={limitMarket == 1 ? "active" : ""} onClick={()=>setLimitMarket(1)}>{t("buyOrder.market")}</p>
                        <p className={limitMarket == 2 ? "active" : ""} onClick={()=>setLimitMarket(2)}>{t("buyOrder.limit")}</p>
                    </div>

                    <div className="available">
                        <h4>{t("buyOrder.available")}</h4>
                        <div className="usdt">{roundFractional(Number(balance))} {coinFrom} <Link to="/account/deposit-crypto"><BuyPlus/></Link></div>
                    </div>

                    <Inputs>
                        { limitMarket === 2 ? <BuyInput placeholder={t("buyOrder.entryPrice")} textData={coinFrom} valueInput={price} setInputChange={priceHandler}/> : ""}
                        <BuyInput placeholder={t("buyOrder.volume")} textData={coinFrom} valueInput={volume} setInputChange={totalHandler}/>
                        <div className="buttons">
                            <div className={leverage == "3" ? "countPercent precentActive" : "countPercent"} onClick={()=>setLeverage("3")}>3x</div>
                            <div className={leverage == "5" ? "countPercent precentActive" : "countPercent"} onClick={()=>setLeverage("5")}>5x</div>
                            <div className={leverage == "10" ? "countPercent precentActive" : "countPercent"} onClick={()=>setLeverage("10")}>10x</div>
                            <div className={leverage == "20" ? "countPercent precentActive" : "countPercent"} onClick={()=>setLeverage("20")}>20x</div>
                        </div>
                        <BuyInput placeholder={t("buyOrder.count")} textData={coinTo} valueInput={count} setInputChange={amountHandler}/>
                    </Inputs>
                    <Inputs className="futuresInputs">
                        <BuyInput placeholder={t("buyOrder.takeProfit")} textData={coinFrom} valueInput={tp} setInputChange={setTP}/>
                        <BuyInput placeholder={t("buyOrder.stopLoss")} textData={coinFrom} valueInput={sl} setInputChange={setSL}/>

                    </Inputs>

                    <Button onClick={handleSubmit} text={t("buyOrder.confirmOrder")}/>
                </div>
            </div>
    </div>
  )
}

export default BuyOrder